import { Link } from 'react-router-dom';
import { ProductCard } from '@molecules/ProductCard';
import { SectionTitle } from '@atoms/SectionTitle';
import type { Product } from '@/types';

interface BestSellerGridProps {
  products: Product[];
  onAdd?: (product: Product) => void;
}

export function BestSellerGrid({ products, onAdd }: BestSellerGridProps) {
  if (!products.length) return null;

  return (
    <section className="section-container py-16 md:py-20">
      <SectionTitle
        title="En Çok "
        accent="Satanlar"
        subtitle="Restoranların en sık tercih ettiği ürünler."
        action={
          <Link to="/search" className="text-sm font-semibold text-brand-600 hover:text-brand-700">
            Tümünü Gör →
          </Link>
        }
      />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} onAdd={onAdd} showWholesaler />
        ))}
      </div>
    </section>
  );
}
